module.exports = __webpack_public_path__ + "img/BAY.8ef41f4.png";